import { AUTO, Scale } from "phaser";
import Preloader from './preloader';
import Start from '../start/start';
import Hallway from '../hallway/hallway';
import GameOver from '../gameOver/gameOver';
import Win from '../win/win';
import Credits from '../credits/credits';
import Pause from '../pause/pause';
import Help from '../help/help';
import About from '../about/about';
import Settings from '../settings/settings';
import Game1 from '../game1/ppalScene';
import Game2 from '../game2/ppalScene';
import Game3 from '../game3/ppalScene';
import Game4 from '../game4/ppalScene';
import Game5 from '../game5/ppalScene';
import Game6 from '../game6/ppalScene';
import Game7 from '../game7/ppalScene';
import Game8 from '../game8/ppalScene';
import Game9 from '../game9/ppalScene2';
import Game10 from '../game10/ppalScene';
import Game11 from '../game11/ppalScene';
import Game12 from '../game12/ppalScene';
import Game13 from '../game13/ppalScene';
import Game14 from '../game14/ppalScene';
import YoutubePlayerPlugin from 'phaser3-rex-plugins/plugins/youtubeplayer-plugin.js';


export default {
   type: AUTO,
   width: 800,
    height: 500,
    // physics: {
    //   default: "matter",
    //   matter: {
    //     gravity: { y: 0 },
        
    //     // Enable debug graphics, so we can see the bounds of each physics 
    //     // object in our scene. Note: this can slow things down, so be sure 
    //     // to turn it off when you aren't debugging
    //     debug: false
    //   }
    // },
   physics: {
     default: 'arcade',
     arcade: {
         gravity: { y: 0 },
         debug: false
     }
   },
   scale: {
    // Center vertically and horizontally
    mode: Scale.FIT,
    autoCenter: Scale.CENTER_HORIZONTALLY,
    parent: 'app',
    fullscreenTarget: 'app'
   },
   dom: {
    createContainer: true
  },
  plugins: {
    global: [{
        key: 'rexYoutubePlayer',
        plugin: YoutubePlayerPlugin,
        start: true
    },
    // ...
    ]
  },
   pixelArt: true,
   scene: [Preloader, Start, Win, Credits, GameOver, Hallway, Game1, Game2, Game3, Game4, Game5, Game6, Game7, Game8, Game9, Game10, Game11, Game12, Game13, Game14, Pause, Help, About, Settings],
};

